var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.preloading)?_c('div',[_c('label',[_vm._v(_vm._s(_vm.label))]),_c('autocomplete',{attrs:{"search":_vm.search,"get-result-value":_vm.getResultValue,"debounce-time":500,"default-value":_vm.defaultValue},on:{"submit":_vm.handleSubmit}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }